<template lang="pug">
	div
		.sfc-best-529-plans-widget(v-observe-visibility="trackShownEvent")
			.info-container.side
				.blue-bar
				b-row
					b-col(md="8" cols="12")
						p A good place to start
						h2 See the best 529 plans, personalized for you
					b-col.get-started-button(md="4" cols="12")
						a.btn.sfc-blue(@click="openSavingsCenter(); trackClickEvent()")
							span(v-if="!loadingModal") GET STARTED
							span.spinner(v-else)
								spinner(size="20")

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.sfc-best-529-plans-widget
	a.btn
		float: right
		margin: 0
		margin-top: 7px
		@media (max-width: 767px)
			font-size: body-font-size-sm
	p
		margin-bottom: 5px
		font-weight: body-font-weight
		color: body-font-color
		@media (min-width: 768px) and (max-width: 1199px)
			font-size: body-font-size-sm
		@media (max-width: 767px)
			font-size: body-font-size-sm
	h2
		margin-bottom: 0
		margin-top: 0
		text-align: left!important
		font-size: body-font-size-lg !important
		@media (max-width: 768px)
			margin: 0!important

		@media (min-width: 768px) and (max-width: 1199px)
			font-size: body-font-size-md
		@media (max-width: 767px)
			font-size: body-font-size-md

	.sfc-red-button
		border-color: #D0021B !important
		background-color: #F05B33 !important
		&:hover
			background-color: #e2491f !important
			color: #fff
		color: #fff

	.get-started-button
		text-align: right
		@media(max-width: 991px)
			text-align: center
			a
				float: none !important

		@media(max-width: 576px)
			a
				width: 100%

		@media (max-width: 767px)
			a
				margin-top: 20px
		@media (min-width: 768px)
			a
				margin-top: 20px

</style>

<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import Vue from 'vue'
	import VueObserveVisibility from 'vue-observe-visibility'
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
	Vue.use(VueObserveVisibility)

	export default {
		components: {
			Spinner
		},
		data(){

			let version
			// This is a/b test so we call each version "a" and "b"
			let randomNumber = Math.ceil(Math.random() * 100)

			version = "v3"

			return {
				shownEventAlreadySent: false,
				currentYear: (new Date()).getFullYear(),
				loadingModal: false,
				version
			}
		},

		methods: {
			trackShownEvent(isVisible, entry){
				if(isVisible && !this.shownEventAlreadySent){
					this.shownEventAlreadySent = true
					SfcTrackingService.trackAnalyticsAction("Savings Center Navigation", "show", "In-content Widget - SPA")
				}
			},

			trackClickEvent(){
				SfcTrackingService.trackAnalyticsAction("Savings Center Navigation", "click", "In-content Widget - SPA", 0)
			},

			async openSavingsCenter(){
				if(this.loadingModal){
					return
				}

				this.loadingModal = true

				let token = this.$cookies.get("sfc_primary")
				let collegeSavingsUser = undefined

				let nextStep = undefined

				try{
					if (
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] &&
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "null" &&
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "undefined"
					){
						nextStep = this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
					}
				}
				catch(err){
					nextStep = undefined
				}

				if (token){
					if (this.$store.state.collegeSavingsUserOnboarding  && nextStep){
						window.location.href = `/savings-center/${nextStep}`
						return
					}
				}

				const query = `
					query{
						no_graphql_cache()
						college_savings_user_v3(sfc_token: "${token}"){
							id
							next_step_v3
							type_of_user
							children{
								id
								name
								age
							}
							state{
								id
								name
								slug
							}
							email
							primary_id
						}
					}
				`

				try {
					let result = await this.$httpService.graphql(query)
					collegeSavingsUser = result.data.college_savings_user_v3
				} catch (e) {
					collegeSavingsUser = undefined

				}

				if (collegeSavingsUser && collegeSavingsUser.next_step_v3){
					window.location.href = `/savings-center/${collegeSavingsUser.next_step_v3}`
					return
				}

				this.$sfcModal.open("sfc-onboarding-modal-v3-2")

				this.loadingModal = false
			},
		},
	}
</script>
